export const qualificationReferenceTemplate: { title: string; items: string[] }[] = [
  {
    title: "1. Situation actuelle",
    items: [
      "Disponible de suite / en mission / en CDI ?",
      "Poste ou mission recherché(e)",
      "Entreprise actuelle ou précédente, localisation",
      "Statut juridique (salarié, indépendant, intérimaire...)",
      "Raison du départ / de l'écoute du marché",
    ],
  },
  {
    title: "2. Expérience terrain",
    items: [
      `Types de projets / chantiers / activités précises — aller au-delà du général (ex. pas juste "a travaillé sur des chantiers de travaux publics", mais "création de voirie, terrassement, création de lotissement...")`,
      "Entreprise 1 : poste, durée, tâches et projets, pourquoi parti, référents",
      "Entreprise 2 : poste, durée, tâches et projets, pourquoi parti, référents",
      "Autres référents",
    ],
  },
  {
    title: "3. Poste recherché",
    items: [
      "Statut recherché (CDI, CDD, Indépendant, Intérim...)",
      "Environnement technique / corps de métier",
      "Télétravail souhaité",
      "Niveau d'anglais",
    ],
  },
  {
    title: "4. Mobilité",
    items: ["Permis / véhiculé", "Ouvert aux grands déplacements ?", "Temps ou distance max accepté"],
  },
  {
    title: "5. Rémunération",
    items: [
      "Salaire / TJM actuel",
      "Avantages (RTT, tickets restaurant, primes, véhicule...)",
      "Prétentions salariales",
      "Négociable jusqu'à",
    ],
  },
  {
    title: "6. Habilitations & équipement",
    items: [
      "Diplômes / habilitations",
      "EPI (casque, gilet, gants, chaussures, pantalon)",
      "Carte BTP",
      "VM (visite médicale)",
    ],
  },
  {
    title: "7. Administratif",
    items: ["Nationalité / titre de séjour", "CNI française ou autre", "Casier judiciaire"],
  },
  {
    title: "8. Décision & suite",
    items: [
      "Critères de décision prioritaires",
      "Pistes évoquées (entreprise, poste, étape du process, localisation)",
      "Opportunités ASAP.WORK présentées (client, poste, réaction du candidat)",
      "Date de l'entretien physique ou visio",
    ],
  },
];
